import React from 'react';
import {
  onSubmitForm,
  pageRequest,
  hideSaveAppPermissionModal,
} from 'actions/employees/pin';
import { connect } from 'react-redux';
import { isDirty } from 'redux-form';
import { Link, browserHistory } from 'react-router';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { askConfirmAction } from 'actions/confirm-action/index';
import { push } from 'react-router-redux';
import NoDataAndLoading from 'components/NoDataAndLoading';
import {
  LeftColumnWrapper,
  PageWrapper,
  PageWrapperVersionTwo,
} from 'components/wrappers/pages';
import { SUBMITTING_GET_PERMISSIONS } from 'actions/employees/pin/constants';

import MenuTitle from 'components/MenuTitle';
import WarningMessage from 'components/WarningMessage/WarningMessage';
import AdministratorList from 'pages/Employees/Pin/AdministratorList';
import withFeatureFlags from 'hocs/withFeatureFlags';
import SaveAppPermissionModal from './SaveAppPermissionModal';
import styles from './Pin.css';
import PinForm from './PinForm';

class Pin extends React.Component {
  componentDidMount() {
    const { dispatch, user } = this.props;
    dispatch(pageRequest({ user }));
    browserHistory.listenBefore(location => {
      // this is still hacky, don't copy paste this
      if (this.props.isDirtyPin && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  render() {
    const {
      submitting,
      allowedFields,
      showSaveAppPermissionModal,
      saveAppPermissionModal,
      outletsEmployees,
      pinAccessImprovement,
    } = this.props;
    const accessDenied = !allowedFields.length;
    const onLoadData = submitting === SUBMITTING_GET_PERMISSIONS;
    const Component = pinAccessImprovement
      ? PageWrapperVersionTwo
      : PageWrapper;

    // we use tricky open right column to separate left-right evenly and loadingspinner to show accessDenies
    return (
      <div>
        <MenuTitle menuTitle="PIN Access" />
        <div className="col-md-12 content-pin-access">
          <Component>
            {(onLoadData || accessDenied) && (
              <LeftColumnWrapper openRightColumn={false}>
                <div className={styles['loading-wrapper']}>
                  <NoDataAndLoading
                    showLoadingSpinner={onLoadData}
                    noDataToDisplay={accessDenied}
                    image={require('assets/images/access-denied.png')}
                    title="Access Denied"
                    description="You're not authorized to access this privilege."
                  />
                </div>
              </LeftColumnWrapper>
            )}
            {!onLoadData && (
              <div>
                {pinAccessImprovement && (
                  <div>
                    <div className={styles.description}>
                      PIN Access is a feature to lock certain access in Moka
                      Apps.
                      <div className={styles['description-subtext']}>
                        This PIN configuration will apply to outlets who have
                        staff with PIN assigned and allowed to use PIN for
                        in-app permission as set on{' '}
                        <Link to="/employees/staff">Employee Slots</Link>, and
                        have access to mobile apps, as set on{' '}
                        <Link to="/employees/role">Employee Access</Link>.
                      </div>
                      <div
                        style={{
                          marginTop: '20px',
                          marginBottom: '20px',
                          paddingLeft: '0px',
                        }}
                        className={'col-md-12'}
                      >
                        <div
                          style={{
                            paddingLeft: '0px',
                          }}
                          className={
                            'col-md-6 col-lg-4 visible-md visible-lg visible-sm'
                          }
                        >
                          <WarningMessage
                            message="Pin Access requires at least Moka v.26.2 on iOS and Moka v.15.9.1 on Android."
                            iconStyle={`circle`}
                          />
                        </div>
                      </div>
                    </div>
                    <LeftColumnWrapper openRightColumn>
                      <AdministratorList
                        onSubmit={this._onSubmit}
                        outletsEmployees={outletsEmployees}
                      />
                    </LeftColumnWrapper>
                  </div>
                )}
                <LeftColumnWrapper openRightColumn>
                  <PinForm
                    onSubmit={this._onSubmit}
                    allowedFields={allowedFields}
                  />
                </LeftColumnWrapper>
              </div>
            )}
            <ConfirmActionModal />
            <SaveAppPermissionModal
              show={showSaveAppPermissionModal}
              onConfirm={this._onConfirmSaveAppPermissionModal}
              message={saveAppPermissionModal.message}
            />
          </Component>
        </div>
      </div>
    );
  }

  _onSubmit = values => {
    const { dispatch, user } = this.props;
    dispatch(onSubmitForm({ values, user }));
  };

  _onConfirmSaveAppPermissionModal = () => {
    const { dispatch } = this.props;
    dispatch(hideSaveAppPermissionModal());
  };
}

function mapStateToProps(state) {
  const {
    submitting,
    allowedFields,
    showSaveAppPermissionModal,
    saveAppPermissionModal,
    outletsEmployees,
  } = state.employee.pin;
  const { user } = state.moka;
  return {
    isDirtyPin: isDirty('pin')(state),
    nextAction: state.confirmAction.nextAction,
    submitting,
    user: {
      id: user.id,
      is_owner: user.is_owner,
      is_manager: user.is_manager,
    },
    allowedFields,
    showSaveAppPermissionModal,
    saveAppPermissionModal: {
      message: saveAppPermissionModal.message,
    },
    outletsEmployees,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(Pin);

const mapFlagsToProps = flags => ({
  pinAccessImprovement: flags.pinAccessImprovement,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
